import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box } from '@mui/material';
import { useSelector } from 'react-redux';

export default function TableDisplay({ 
    data = [], 
    xKey = 'province',
    yKey = 'count',
    xLabel = 'Category',
    yLabel = 'Value',
    title = 'Data Table',
    description = 'Data in tabular format',
    sortBy = 'desc',
    emptyMessage = 'No data available'
}) {
    const retailer = useSelector(state => state.retailer);
    
    // Sort data based on sortBy prop
    let sortedData = data ? [...data] : [];
    if (sortBy === 'desc') {
        sortedData = sortedData.sort((a, b) => b[yKey] - a[yKey]);
    } else if (sortBy === 'asc') {
        sortedData = sortedData.sort((a, b) => a[yKey] - b[yKey]);
    }

    if (!data || data.length === 0) {
        return (
            <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    {emptyMessage}
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>            
            <Table size='small' sx={{ minWidth: 650 }} aria-label="data table">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 'bold' }}>{xLabel}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{yLabel}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedData.slice(0, 20).map((row, index) => (
                        <TableRow
                            key={row[xKey] || index}
                            sx={{ 
                                '&:last-child td, &:last-child th': { border: 0 },
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' }
                            }}
                        >
                            <TableCell component="th" scope="row">
                                {row[xKey] || 'Unknown'}
                            </TableCell>
                            <TableCell align="right">
                                {typeof row[yKey] === 'number' 
                                    ? row[yKey].toLocaleString() 
                                    : row[yKey]
                                }
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
}